const tintColor = 'peru';
const Primarycolor = '#f8f9fa';
const SecondaryColor = '#4B3C67';
export const palette = {
  primary: {
    50: '#e6e9f2',
    100: '#cad2eb',
    200: '#a8b4d8',
    300: '#8697c6',
    400: '#6579b4',
    500: "#5166A6",
    600: '#394a79',
    700: '#293558',
    800: '#162037',
    900: '#030b19',
  },
  secondary: {
    50: '#f8f8f8',
    100: '#f0f0f0',
    200: '#e6e6e6',
    300: '#d5d5d5',
    400: '#b0b0b0',
    500: '#909090',
    600: '#686868',
    700: '#555555',
    800: '#373737',
    900: '#171717',
  },
}
export default {
  tintColor,

  Primarycolor,
  SecondaryColor,
  red: "#cc0000",
  green: "#198c19",
  blue: "#1919ff",
  yellow: "#ffff19",
  orange: "#ffc107",
  blue_2: "#007aff",
  placeholderTextColor: "rgba(0, 0, 0, 0.42);",
  backgroundScreen: '#FFF',
  white: "#fff",
  //Card 
  titleCard: "#007aff",
  titleCardBorder: "#007aff",

  // Tab
  tabDefaultBg: Primarycolor,
  topTabBarTextColor: "#b3c7f9",
  topTabBarActiveTextColor: "#007aff",
  topTabActiveBgColor: undefined,
  topTabBarBorderColor: "#a7a6ab",
  topTabBarActiveBorderColor: "#007aff",
  // button 
  buttonInfo: "#17a2b8",
  buttonSuccess: "#6AD959",
  bgSuccess: "#d4edda",
  buttonDanger: '#dc3545',
  buttonLight: '#f8f9fa',
  buttonPrimary: "#007bff",
  buttonTransparent: "transparent",
};
